import { AssistantMessageContent, BackQuackItem } from "duck/ui/chat/types";

import { ChartRenderer } from "./ChartRenderer";
import { CriticalErrorMessageRenderer } from "./CriticalErrorMessageRenderer";
import { DownloadableContentRenderer } from "./DownloadableContentRenderer";
import { MarkdownRenderer } from "./MarkdownRenderer";
import { RendererRegistry } from "./RendererRegistry";
import { SuggestedRepairRenderer } from "./SuggestedRepairRenderer";
import { TableRenderer } from "./TableRenderer";
import { WorkOrderPricingVerificationRenderer } from "./WorkOrderPricingVerificationRenderer";

// Create global registry instance
const contentRendererRegistry = new RendererRegistry<AssistantMessageContent>();
const backQuackRendererRegistry = new RendererRegistry<BackQuackItem>();

// Register core built-in renderers
contentRendererRegistry.register(MarkdownRenderer);
contentRendererRegistry.register(TableRenderer);
contentRendererRegistry.register(SuggestedRepairRenderer);
contentRendererRegistry.register(WorkOrderPricingVerificationRenderer);
contentRendererRegistry.register(DownloadableContentRenderer);
contentRendererRegistry.register(ChartRenderer);

backQuackRendererRegistry.register(CriticalErrorMessageRenderer);

// Export the registry (used by MessageContentRenderer)
export { contentRendererRegistry, backQuackRendererRegistry };
